require('../../modules/es6.math.log2');
module.exports = require('../../modules/_core').Math.log2;



// WEBPACK FOOTER //
// node_modules/_core-js@2.5.6@core-js/fn/math/log2.js